import React from "react";
import NoBuyingRights from "./NoBuyingRights";

interface UserBidRightsProps {
  userCanPlaceBid: boolean;
  children: any;
  errorMessageText: string;
}

const UserBidRights: React.FunctionComponent<UserBidRightsProps> = ({
  children,
  userCanPlaceBid,
  errorMessageText,
}) => {
  if (!userCanPlaceBid) {
    return <NoBuyingRights text={errorMessageText} />;
  }

  return children;
};

export default UserBidRights;
